'use client'

import type { Flags } from '@/lib/flags'
import { createContext, useContext } from 'react'

const FlagsContext = createContext<Flags>({})

export const FlagsProvider = ({
  children,
  flags,
}: {
  children: React.ReactNode
  flags: Flags
}) => {
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
}

export const useFlags = () => {
  const flags = useContext(FlagsContext)
  if (!flags) {
    throw new Error('useFlags must be used within a FlagsProvider')
  }
  return flags
}
